import { identity, pickBy } from "lodash"
import { dropEmptyKeys, filterNulls } from "../../utils/helper"
import ListMembersRequest from "./ListMembersRequest"

class ListTargetPersonsByFiltersRequest extends ListMembersRequest {
    
}

export default ListTargetPersonsByFiltersRequest